import type { StatementContentEncoding } from "@/lib/api";

/** Browser transport only. The API remains authoritative for parsing and limits. */
export function readStatementFile(file: File): Promise<{
  content: string;
  contentEncoding: StatementContentEncoding;
}> {
  if (/\.pdf$/i.test(file.name) || file.type === "application/pdf") {
    return Promise.reject(new Error("PDF bytes must go through the statement's PDF review, not the text/workbook reader."));
  }
  const workbook = /\.xlsx?$/i.test(file.name);
  if (file.size > (workbook ? 2 : 5) * 1024 * 1024) {
    return Promise.reject(new Error(`The statement exceeds the ${workbook ? 2 : 5} MiB import limit.`));
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const value = String(reader.result ?? "");
      resolve({
        content: workbook ? value.slice(value.indexOf(",") + 1) : value,
        contentEncoding: workbook ? "base64" : "text",
      });
    };
    reader.onerror = reader.onabort = () => reject(new Error(`Could not read ${file.name}. Please choose the file again.`));
    if (workbook) reader.readAsDataURL(file);
    else reader.readAsText(file);
  });
}
